import { Link } from 'react-router-dom';
import { useLanguageContext } from '@/i18n/LanguageContext';

const COVER_ALT_JA = '『執事のマナーと教養図鑑』(Gakken)全日本執事協会 3代目執事ベル監修の書影';
const COVER_ALT_EN =
  "Cover image of Gakken's A British Butler's Guide to Manners and Culture, supervised by Butler Bell III of the All Japan Butler Association";
const ARIA_LABEL_JA = '『執事のマナーと教養図鑑』(Gakken・全日本執事協会 3代目執事ベル監修)の詳細ページを見る';
const ARIA_LABEL_EN =
  "See the detail page for Gakken's A British Butler's Guide to Manners and Culture, supervised by Butler Bell III of the All Japan Butler Association";
const HEADING_JA = '全日本執事協会 3代目執事ベル監修の書籍';
const HEADING_EN = 'A Book Supervised by Butler Bell III of the All Japan Butler Association';
const BOOK_TITLE_JA = '『執事のマナーと教養図鑑』';
const BOOK_TITLE_EN = "A British Butler's Guide to Manners and Culture";
const BOOK_SUBTITLE_JA = '英国紳士の美しい暮らしかた 50 Topics';
const BOOK_SUBTITLE_EN = 'How to Live Elegantly — 50 Topics';
const SUPERVISOR_JA = '全日本執事協会 3代目執事ベル';
const SUPERVISOR_EN = 'Butler Bell III, All Japan Butler Association';
const COOPERATOR_JA = '執事喫茶 Swallowtail';
const COOPERATOR_EN = 'Butler Café Swallowtail';
const LEAD_JA = '英国執事の所作と教養を、50 の話題でたどる一冊。本書の監修を全日本執事協会 3代目執事ベルが務めました。';
const LEAD_EN =
  'Fifty topics that trace the manners and culture of the British butler. Butler Bell III of the All Japan Butler Association served as its supervising editor.';
const CTA_JA = '詳しく見る →';
const CTA_EN = 'Read more →';

export default function HeroBookBadge() {
  const { lang } = useLanguageContext();
  const isEn = lang === 'en';
  const heading = isEn ? HEADING_EN : HEADING_JA;
  const alt = isEn ? COVER_ALT_EN : COVER_ALT_JA;
  const ariaLabel = isEn ? ARIA_LABEL_EN : ARIA_LABEL_JA;
  const localize = (ja: string, en: string) => (isEn ? en : ja);

  return (
    <section
      className="tjba-hb-section hero-book-badge tjba-hb"
      aria-labelledby="tjba-hb-heading"
      data-lang={lang}
    >
      <p className="tjba-hb-kicker">BOOK</p>
      <h2 id="tjba-hb-heading" className="tjba-hb-heading">
        {heading}
      </h2>
      <Link
        className="tjba-hb-link tjba-hb-image-link"
        to={isEn ? '/en/book/butler-manners-and-culture' : '/book/butler-manners-and-culture'}
        aria-label={ariaLabel}
      >
        <picture className="tjba-hb-picture">
          <source media="(max-width: 1000px)" srcSet="/images/book/gakken-book-link-sp.png" />
          <img
            className="tjba-hb-image"
            src="/images/book/gakken-book-link.png"
            srcSet="/images/book/gakken-book-link.png 1x, /images/book/gakken-book-link@2x.png 2x"
            width="560"
            height="717"
            alt={alt}
            loading="eager"
            decoding="async"
          />
        </picture>
        <div className="tjba-hb-copy">
          <p className="tjba-hb-title">{localize(BOOK_TITLE_JA, BOOK_TITLE_EN)}</p>
          <p className="tjba-hb-subtitle">{localize(BOOK_SUBTITLE_JA, BOOK_SUBTITLE_EN)}</p>
          <dl className="tjba-hb-meta">
            <div>
              <dt>{localize('監修', 'Supervised by')}</dt>
              <dd>{localize(SUPERVISOR_JA, SUPERVISOR_EN)}</dd>
            </div>
            <div>
              <dt>{localize('協力', 'In cooperation with')}</dt>
              <dd>{localize(COOPERATOR_JA, COOPERATOR_EN)}</dd>
            </div>
            <div className="tjba-hb-meta-publisher">
              <dt>{localize('出版', 'Published by')}</dt>
              <dd>Gakken</dd>
            </div>
          </dl>
          <p className="tjba-hb-lead">{localize(LEAD_JA, LEAD_EN)}</p>
          <span className="tjba-hb-cta">{localize(CTA_JA, CTA_EN)}</span>
        </div>
      </Link>
    </section>
  );
}
